import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import CryptoJS from "crypto-js";
import config from '../config.json';

const cognitoConfigJSON = config;

const ROLES = {
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
  CONTENT: "content"
}

const USER_ATTRIBUTES = {
  EMAIL: "email",
  EMAIL_VERIFIED: "email_verified",
  ROLE: "custom:role",
}

const DEFAULT_EMAIL_VERIFY = "true";

/** Cognito Secret Hash */
const generateSecretHash = (username, clientId, clientSecret) => {
  return CryptoJS.HmacSHA256(username + clientId, clientSecret).toString(CryptoJS.enc.Base64);
}

/** CognitoIdentityProviderClient */
const cognitoIdentityProviderClient = new CognitoIdentityProviderClient({ region: config.region });

/** Cognito IdentityClient - Authentication Id Token */
const AuthenticationIdToken = async (Username = config.Username, Password = config.Password) => {
  const secretHash = generateSecretHash(Username, config.clientId, config.clientSecret);
  const input = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: config.clientId,
    AuthParameters: {
      USERNAME: Username,
      PASSWORD: Password,
      SECRET_HASH: secretHash,
    },
  };

  const command = new InitiateAuthCommand(input);
  const response = await cognitoIdentityProviderClient.send(command);
  return response.AuthenticationResult?.IdToken;
};


/** CognitoIdentityProviderClient */
const cognitoClientProvider = async () => {
  const authenticationIdToken = await AuthenticationIdToken();
  return new Promise((resolve, reject) => {
    try {
      const client = new CognitoIdentityProviderClient({
        region: config.region,
        credentials: fromCognitoIdentityPool({
          client: new CognitoIdentityClient({ region: config.region }),
          identityPoolId: config.identityPoolId,
          logins: { [`cognito-idp.${config.region}.amazonaws.com/${config.userPoolId}`]: authenticationIdToken },
        }),
      });
      resolve(client);
    }
    catch (error) {
      reject(error);
    }
  });
}

/** CognitoIdentityProviderClient - Amplify Gen2 */
export const cognitoClientProviderForAmplify = async (userDataDetail) => {
  if (userDataDetail) {
    const client = new CognitoIdentityProviderClient({
      region: cognitoConfigJSON.region,
      credentials: {
        accessKeyId: userDataDetail?.credentials?.accessKeyId,
        secretAccessKey: userDataDetail?.credentials?.secretAccessKey,
        sessionToken: userDataDetail?.credentials?.sessionToken
      },
    });
    if (client) {
      return client;
    }
    else {
      return null;
    }
  }
  else {
    return null;
  }
}

export {
  ROLES,
  USER_ATTRIBUTES,
  DEFAULT_EMAIL_VERIFY,
  cognitoConfigJSON,
  generateSecretHash,
  AuthenticationIdToken,
  cognitoClientProvider,
  cognitoIdentityProviderClient,
}